// extracted by mini-css-extract-plugin
export default {"chart":"style_chart__vYfCC"};